import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import CheckboxSelectFilter from '../../../../Filters/CheckboxSelectFilter';
import { UserRolePermissions } from '../../../../../constants';

const CustomerBookedTripFilter = ({ onSearch }) => {
  const { tripsSearch } = useSelector((store) => store.trip);
  const { travelAgency } = useSelector((store) => store.user);
  const doShowBookedByCustomer =
    travelAgency &&
    travelAgency.permissions &&
    travelAgency.permissions.anonymous &&
    _.find(
      travelAgency.permissions.anonymous,
      (p) =>
        p === UserRolePermissions.canBook ||
        p === UserRolePermissions.canHold ||
        p === UserRolePermissions.canBookFromTripQuote ||
        p === UserRolePermissions.canSendEmailQuote ||
        p === UserRolePermissions.canSendBrochure,
    );

  const options = [
    {
      suggests: [
        {
          value: true,
          label: 'Only show trip booked by customer',
        },
      ],
      label: '',
      value: '',
    },
  ];

  const handleCruisePayment = useCallback(
    (selectedOptionsValue) => {
      const searchObj = {
        ...tripsSearch.searchObj,
        onlyTripBookedByCustomer: selectedOptionsValue && selectedOptionsValue[0],
        page: 1,
      };
      onSearch(searchObj);
    },
    [onSearch, tripsSearch.searchObj],
  );

  return doShowBookedByCustomer ? (
    <CheckboxSelectFilter
      onChange={handleCruisePayment}
      options={options[0].suggests}
      values={
        tripsSearch.searchObj.onlyTripBookedByCustomer
          ? [tripsSearch.searchObj.onlyTripBookedByCustomer]
          : []
      }
      label="Show trip booked by customer"
      variant="outline"
      sortField="discounts"
      filterMaxWidthClass="max-w"
    />
  ) : null;
};

CustomerBookedTripFilter.propTypes = {
  onSearch: PropTypes.func.isRequired,
};

export default CustomerBookedTripFilter;
